// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__1xDMC","push-right":"Table_push-right__1MYaZ"};